import { authenticate } from '../auth0';
import { redirectToSignIn } from '../redirect/redirect';
import { logAPIErrorToNewrelic } from '../wishList/utils';

export * from './jsonParser';

export const webRequest = async (
    url: string,
    data: RequestInit = {},
    redirectOn401 = true,
): Promise<Response | null> => {
    const accessToken = await authenticate();

    if (!accessToken) logAPIErrorToNewrelic('webRequest', 'Auth Failed with empty token');

    try {
        const defaultHeader = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        };
        data.headers = Object.assign(
            defaultHeader,
            data.headers || {},
            accessToken ? { Authorization: accessToken } : {},
        );
        const result = await fetch(url, {
            credentials: accessToken ? 'include' : 'omit',
            ...data,
        });
        if (result.status === 401) {
            logAPIErrorToNewrelic(`webRequest`, `UNAUTHORISED - 401`, {
                ...result,
                response: result,
                url: url,
                data: data,
                redirectOn401: redirectOn401,
            });
            if (redirectOn401) {
                redirectToSignIn();
            }
        }
        return result;
    } catch (e) {
        logAPIErrorToNewrelic('webRequest', 'Swallowed exception', {
            exception: e,
        });
    }
    return null;
};

export enum METHOD {
    POST = 'POST',
    DELETE = 'DELETE',
}
